import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { GraphQlService } from '@shared/services/graphql-service';
import { SwalService } from '@shared/services/swal.service';
import { ApolloNamespace } from '@shared/enums/apollo-namespaces';
import { GET_ALL_REFERENCE_DATA } from '../planning.graphql';
import { GetAllReferenceDataResponse } from '../types/reference-data';
import { ReferenceDataActions } from './reference-data.actions';

@Injectable()
export class ReferenceDataEffects {
  private readonly actions$ = inject(Actions);
  private readonly graphqlService = inject(GraphQlService);
  private readonly swalService = inject(SwalService);

  loadAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReferenceDataActions.loadAll),
      switchMap(() =>
        this.graphqlService
          .query<GetAllReferenceDataResponse>({
            query: GET_ALL_REFERENCE_DATA,
            apolloNamespace: ApolloNamespace.registration,
          })
          .pipe(
            map((response) =>
              ReferenceDataActions.loadAllSuccess({
                items: response.data?.getAllReferenceData?.content ?? [],
              })
            ),
            catchError((error) => of(ReferenceDataActions.loadAllFailure({ error })))
          )
      )
    )
  );

  notifications$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ReferenceDataActions.loadAllFailure),
        tap(() => {
          this.swalService.errorToast('Failed to load reference data');
        })
      ),
    { dispatch: false }
  );
}
